import ImgPost from "../../../../src/components/imgPost";
import LinkPost from "../../../../src/components/linkPost";
import WebpackSummary from "../../../../contents/posts/11-webpack-part-3/1.svg";
import * as React from 'react';
export default {
  ImgPost,
  LinkPost,
  WebpackSummary,
  React
};